import * as types from './mutation-types'
import constants from '@/util/constants'
import axios from 'axios'
import util from '@/util'

export const ActionDefinirSePossuiNegociador = ({ commit }, possuiNegociador) => {
  commit(types.SET_POSSUI_NEGOCIADOR, possuiNegociador)
}

export const ActionDefinirListaPermissoesDosistema = async ({ commit }) => {
  const resposta = await axios.get('/permissoes')
  return resposta.data.retorno.dados
}

export const ActionDefinirListaNegociadoresDoUsuario = ({ commit }, listaNegociadoresDoUsuario) => {
  commit(types.SET_LISTA_NEGOCIADORES_USUARIO, listaNegociadoresDoUsuario)
}

export const ActionDefinirListaUnidades = async ({ commit }, parametrosRequisicao) => {
  const resposta = await axios.post('/unidades', parametrosRequisicao)
  commit(types.SET_LISTA_UNIDADES, resposta.data.retorno.dados)
}

export const ActionDefinirListaCoordenadores = async ({ commit }, parametrosRequisicao) => {
  const resposta = await axios.post('/coordenadores', parametrosRequisicao)
  commit(types.SET_LISTA_COORDENADORES, resposta.data.retorno.dados)
}

export const ActionDefinirListaCapas = async ({ commit }, parametrosRequisicao) => {
  const resposta = await axios.post('/capas', parametrosRequisicao)
  commit(types.SET_LISTA_CAPAS, resposta.data.retorno.dados)
}

export const ActionResetarListaTiposAcao = async ({ commit }) => {
  commit(types.SET_LISTA_TIPOS_ACAO, [])
}

export const ActionDefinirListaTiposAcao = async ({ commit }, parametrosRequisicao) => {
  const resposta = await axios.post('/areas/acoes', parametrosRequisicao)
  commit(types.SET_LISTA_TIPOS_ACAO, resposta.data.retorno.dados)
}

export const ActionResetarDadosAbasCadastro = ({ commit }) => {
  commit(types.SET_LISTA_MERGE_PERMISSOES_USUARIO_SISTEMA, [])
  commit(types.SET_LISTA_NEGOCIADORES_USUARIO, [])
  commit(types.SET_POSSUI_NEGOCIADOR, false)
  commit(types.SET_LISTA_PERMISSOES_USUARIO, [])
  commit(types.SET_DADOS_PERFIL_USUARIO, [])
}

export const ActionDefinirDadosPerfilUsuario = ({ commit }, dadosPerfil) => {
  if (!util.valorEhNulo(dadosPerfil.coordinator)) {
    dadosPerfil.coordinator = { label: dadosPerfil.coordinator.user.f_name, code: dadosPerfil.coordinator.f_id }
  }

  if (!util.valorEhNulo(dadosPerfil.f_type)) {
    let id = dadosPerfil.f_type
    let nome = (id === constants.tipoCorrespondente.comum) ? constants.tipoCorrespondente.comumLabel : constants.tipoCorrespondente.parceiroLabel
    dadosPerfil.f_type = { label: nome, code: id }
  }

  commit(types.SET_DADOS_PERFIL_USUARIO, dadosPerfil)
}

export const ActionDefinirListaEstados = async ({ commit }, parametrosRequisicao) => {
  const resposta = await axios.post('/unidades-federativas', parametrosRequisicao)
  commit(types.SET_LISTA_ESTADOS, resposta.data.retorno.dados)
}

export const ActionDefinirDadosPerfilAdvogado = ({ commit }, dadosSalvosPerfilAdvogado) => {
  commit(types.SET_DADOS_SALVOS_PERFIL_ADVOGADO, dadosSalvosPerfilAdvogado)
}

export const ActionResetarDadosFormularioUsuario = ({ commit }) => {
  commit(types.SET_DADOS_FORMULARIO_USUARIO, {
    f_id: null,
    f_name: null,
    f_username: null,
    f_sede: null,
    f_extension: '',
    f_role: null,
    f_password: null,
    f_password_confirm: null,
    f_status: 2,
    f_daysweek: [],
    f_birthday: null,
    f_office: null,
    f_email: null,
    f_hour_begin: '00:00',
    f_hour_end: '23:59',
    f_coordinator: false,
    f_reviewer: false,
    f_int_permissions: [],
    f_areas: [],
    f_permissions: [],
    f_profiles: [],
    f_profile_data: [],
    f_photo: []
  })
}
export const ActionResetarDadosRetornoCadastro = ({ commit }) => {
  commit(types.SET_DADOS_RETORNO_CADASTRO, {
    sucesso: false,
    mensagem: '',
    listaDeErros: {}
  })
}
